/* BLISART - SELECTOR DE IDIOMAS en el menu desplegable.
   Delegado en document: sobrevive a los repintes del header. */
(function () {
  "use strict";

  function panel() { return document.getElementById("nbMenu"); }

  function cerrar() {
    var p = panel();
    if (!p) return;
    var w = p.querySelector(".nb-lang.is-open");
    if (!w) return;
    w.classList.remove("is-open");
    var b = w.querySelector(".nb-lang__btn");
    if (b) b.setAttribute("aria-expanded", "false");
  }

  function abrir(w) {
    cerrar();
    w.classList.add("is-open");
    var b = w.querySelector(".nb-lang__btn");
    if (b) b.setAttribute("aria-expanded", "true");
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest(".nb-lang__btn");
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var w = btn.closest(".nb-lang");
      if (w.classList.contains("is-open")) cerrar(); else abrir(w);
      return;
    }

    var opt = t.closest(".nb-lang__opt");
    if (opt) {
      e.stopPropagation();
      cerrar();
      return;
    }

    if (t.closest("#nbMenu")) {
      if (!t.closest(".nb-lang")) cerrar();
      return;
    }
    cerrar();
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") cerrar();
  });
})()
